import { render, staticRenderFns } from "./RecoveryPasswordForm.vue?vue&type=template&id=e868ac26&"
import script from "./RecoveryPasswordForm.vue?vue&type=script&lang=js&"
export * from "./RecoveryPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputText: require('/home/runner/work/lareverde-shop/lareverde-shop/components/inputs/InputText.vue').default})
